import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import tinycolor from 'tinycolor2';
import { useChangeLangModal } from '../../screens/change-lang-modal';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseLanguageFlag } from '../../utils/manager/i18n-manager';

function ChangeLangButton({ selectedLanguage }) {
  const classes = useStyles();
  const { prepareChangeLangModal, showChangeLangModal } = useChangeLangModal();

  const changeLanguage = async () => {
    await prepareChangeLangModal();
    await showChangeLangModal();
  };

  return (
    <div
      className={classNames(
        classes.container,
        'animate__animated animate__fadeInDown animate__delay-1s'
      )}
      style={{ '--animate-delay': '1.1s' }}
      onClick={changeLanguage}
      onKeyDown={changeLanguage}
      role="button"
      tabIndex="0"
    >
      <img
        src={parseLanguageFlag(selectedLanguage)}
        alt="country flag"
        className={classes.flag}
      />
      <div className={classes.borderOverlay} />
    </div>
  );
}
const useStyles = createUseStyles({
  container: {
    position: 'absolute',
    top: layoutDefaults.biggerVerticalMargin,
    left: layoutDefaults.biggerHorizontalMargin,
    height: 36,
    width: 36,
    filter: `drop-shadow(0px 3px 3px ${tinycolor(layoutDefaults.buttonBorder)
      .setAlpha(1)
      .darken(6)
      .toRgbString()})`,

    // border: '1px solid #fff',
  },
  borderOverlay: {
    position: 'absolute',
    top: 2,
    left: 2,
    height: 30,
    width: 30,
    zIndex: -1,
    borderRadius: '50%',
    opacity: 0.65,
    border: '1px solid #fff',
  },
  flag: {
    position: 'absolute',
    height: 34,
  },
});

export { ChangeLangButton };
